import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeparturesIcon from '@material-ui/icons/FlightTakeoff';
import FlightsIcon from '@material-ui/icons/Flight';
import LoginIcon from '@material-ui/icons/ConfirmationNumber';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import Departures from "./components/departures/index";
import Login from "./components/auth/index";
import Flights from "./components/flights/index";
import FlightOps from "./components/ops/index"
import FlightOpsV2 from './components/ops-v2';
import { useSelector } from "react-redux";
import { Switch, Route, withRouter, Link, Redirect } from 'react-router-dom';
import { checkPermissions } from './components/auth/storage'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  navLink: {
    color: 'black',
    textDecoration: 'none'
  }
}));

// SECTION navBar
const NavListItem = (props) => {
  const classes = useStyles();

  function iconFinder(label) {
    switch (label) {
      case "Flights":
        return <FlightsIcon />
      case "Departures":
        return <DeparturesIcon />
      case "Login":
        return <LoginIcon />
      case "FlightOps":
        return <InsertInvitationIcon />
      default:
        return
    }
  }

  if (props.hasAccess || props.label == 'Login') {
      return (
      <Link to={`/${props.label.toLowerCase()}`} className={classes.navLink}>
        <ListItem button>
          <ListItemIcon>{iconFinder(props.label)}</ListItemIcon>
          <ListItemText >{props.label}</ListItemText>
        </ListItem>
      </Link>
    )
  }
  else {
    return <div></div>
  }
}

const MainDisplay = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  let [page, setPage] = React.useState('Flights')
  let loggedIn = useSelector(state => state.auth.fredAccessToken);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            {page}
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          <NavListItem label={"Flights"} hasAccess={loggedIn} />
          <NavListItem label={"Departures"} hasAccess={loggedIn} />
          <NavListItem label={"FlightOps"} hasAccess={loggedIn}/>
          {/* <NavListItem label={"FlightOps_v2"} hasAccess={loggedIn}/> */}
          <NavListItem label={"Login"} />
        </List> 
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {/* !SECTION */}
        {/* SECTION // Routes (page displayed) */}
        <div>
          <Switch>
            <Route exact path={["/flights", '/']} render={(props) => {
              setPage('Flights')
              if (loggedIn) {
                return (
                  <Flights {...props} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }}/>
            {/* <Route exact path="/flights/:id" render={(props) =>{
              setPage(`Flights Edit ${props.match.params.id}`)
              if (loggedIn) {
                return (
                  <Flights />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }}/> */}
            <Route exact path="/departures" render={(props) => {
              setPage('Departures')
              if (loggedIn) {
                return (
                  <Departures {...props} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            }/>
            <Route exact path="/flightOps" render={(props) => {
              // FIXME // I can't figure out why setPage() isn't working here
              setPage('Flight Ops')
              if (loggedIn) {
                return (
                  <FlightOpsV2 {...props} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            }/>
             <Route exact path="/flightOps_v2" render={(props) => {
              // FIXME // I can't figure out why setPage() isn't working here
              setPage('Flight Ops')
              if (loggedIn) {
                return (
                  <FlightOpsV2 {...props} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            }/>
            <Route exact path="/departures/:id" render={(props) =>{
              setPage(`Departures Edit ${props.match.params.id}`)
              return (
                <div>
                  <p>departures/:id</p>
                </div>
              )
            }}/>
            <Route exact path="/login" render={(props) => {
              setPage('Login')
              return (
                <Login {...props} />
              )
            }
            }/>

            {/* <Route exact path="/reservations/:id" render={(props) =>{
              setPage(`Reservations Edit ${props.match.params.id}`)
              return (
                <div>
                  <p>reservations/:id</p>
                </div>
              )
            }}/> */}
          </Switch>
        </div>
        {/* !SECTION */}
      </main>
    </div>
  );
}

export default withRouter(MainDisplay)